import React, { Component } from 'react'
import validator from 'validator'
import { Trans } from 'react-i18next'

export const required = value => (value ? undefined : ' ')

export const requiredMultiSelect = value => {
  return value && value.length ? undefined : ' '
}

export const url = value =>
  validator.isURL(value) ? undefined : `Введите корректный URL`

export const email = value =>
  validator.isEmail(value) ? (
    undefined
  ) : (
    <Trans i18nKey="validation.email">Введите корректный Email</Trans>
  )

export const minLength = value =>
  value.length < 8 ? (
    <Trans i18nKey="validation.minLength">
      {`Количество символов \n должно быть больше 8`}
    </Trans>
  ) : (
    undefined
  )

export const maxLength = value => {
  let options = { min: 0, max: 30 }
  return validator.isLength(new String(value), options)
    ? undefined
    : `Количество символов \n не должно быть больше ${options.max}`
}

export const asyncValidate = async values => {
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

  await sleep(1000)

  if (['test@mail.ru'].includes(values.email)) {
    return Promise.reject({
      email: `Этот email зарегистрирован.`,
    })
  }
}

export const phone = value =>
  value.length < 8 ? (
    <Trans i18nKey="validation.phone">{`Введите номер полностью`}</Trans>
  ) : (
    undefined
  )
